<template>
  <div>
    <div :id="VIEW_LIST" v-if="viewType == VIEW_LIST">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:right;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:left;">Group Type</th>
                    <th style="text-align:right;">Quota</th>
                    <th style="text-align:left;">Main Guest</th>
                    <th style="text-align:left;">Company</th>
                    <th style="text-align:left;">NPWP</th>
                    <th style="text-align:left;">Address1</th>
                    <th style="text-align:left;">Address2</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:center;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td style="text-align:left;">{{ row.name }}</td>
                    <td style="text-align:left;">{{ row.typeName }}</td>
                    <td style="text-align:right;">{{ row.quota }}</td>
                    <td style="text-align:left;">{{ row.mainGuestName }}</td>
                    <td style="text-align:left;">{{ row.company }}</td>
                    <td style="text-align:left;">{{ row.npwp }}</td>
                    <td style="text-align:left;">{{ row.address1 }}</td>
                    <td style="text-align:left;">{{ row.address2 }}</td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.mainGuestId }}</td>
                    <td hidden>{{ row.type }}</td>                   
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div :id="VIEW_FORM" v-if="viewType == VIEW_FORM">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent role="form">
                <div class="box-body">
                  <div class="form-group">
                    <label for="inputName">Name</label>
                    <h1 style="margin-top:0px;">
                      <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Group Name" v-model="formData.name">
                    </h1>                        
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="nav-tabs-custom">
                        <ul class="nav nav-tabs">
                          <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General</a></li>
                          <li v-bind:class="{ active: tabActive == TAB_GUESTGROUP }"><a @click="onClickTabGuestGroup()" href="#tab_2" data-toggle="tab" aria-expanded="true">Guest of Group</a></li>
                        </ul>
                      </div>
                      <div class="tab-content">
                        <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                          <div class="box no-border form-horizontal">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputProductType" class="col-sm-4 control-label">Group Type</label>
                                  <div class="col-sm-8">
                                    <select v-model="formData.type" class="form-control" :disabled="viewMode == MODE_VIEW">
                                      <option v-for="(row, i) in listGroupType" v-bind:key="i" v-bind:value="row.id">
                                        {{ row.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>                                         
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputQuota" class="col-sm-4 control-label">Quota</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputQuota" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputQuota" placeholder="" v-model="formData.quota">
                                  </div>
                                </div>                      
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputCompany" class="col-sm-4 control-label">Company</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputCompany" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputCompany" placeholder="" v-model="formData.company">
                                  </div>
                                </div>                                         
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputMainGuest" class="col-sm-4 control-label">Main Guest</label>
                                  <div class="col-sm-8">
                                    <!-- <select v-model="formData.mainGuestId" class="form-control" :disabled="viewMode == MODE_VIEW" @keyup="onMainGuestKeyUp($event)">
                                      <option v-for="(row, i) in listGuest" v-bind:key="i" v-bind:value="row.id">
                                        {{ row.firstName + ' ' + row.lastName }}
                                      </option>
                                    </select> -->
                                    <input type="text" ref="inputMainGuest" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputMainGuest" v-model="formData.mainGuestName"
                                          list="listMainGuest" @change="onGetMainGuest($event)" @keyup="onSearchMainGuest($event)" placeholder="" >
                                    <datalist id="listMainGuest">
                                      <option v-for="(row, i) in listGuest" :key="i" :value="row.firstName + ' ' + row.lastName"></option>
                                    </datalist>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputNPWP" class="col-sm-4 control-label">NPWP</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputNPWP" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputNPWP" placeholder="" v-model="formData.npwp">
                                  </div>
                                </div>                                         
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputAddress1" class="col-sm-4 control-label">Address 1</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputAddress1" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputAddress1" placeholder="" v-model="formData.address1">
                                  </div>
                                </div>                                 
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">                                        
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputAddress2" class="col-sm-4 control-label">Address 2</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputAddress2" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputAddress2" placeholder="" v-model="formData.address2">
                                  </div>
                                </div>                                
                              </div>
                            </div>                                                                                  
                          </div>
                        </div>
                        <div v-bind:class="{ active: tabActive == TAB_GUESTGROUP }" class="tab-pane" id="tab_2">
                          <div class="box no-border">
                            <div class="box-header">         
                              <div class="box-tools" v-if="viewMode != MODE_VIEW">              
                                <button class="btn btn-primary" data-toggle="modal" data-target="#modal-addGuest" v-on:click="onCreateGuestGroup(data)">Add Guest</button>
                              </div>
                            </div>                                                         
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;" v-if="viewMode != MODE_VIEW">Action</th>
                                    <th style="text-align:left;">Guest</th>
                                    <!-- <th style="text-align:right;">In Quota</th> -->
                                    <th style="text-align:left;">Relationship</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listGuestGroup" v-bind:key="i">
                                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td style="width:85px;text-align:center;" v-if="viewMode != MODE_VIEW">
                                      <!-- <a href="#" v-on:click="onDisplayGuestGroup(row)" ref="displayRow" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                      </a> -->
                                      <!-- <a href="#" v-on:click="onEditGuestGroup(row)" ref="editRow" style="padding-right:5px" data-toggle="modal" data-target="#modal-addGuest">
                                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                      </a> -->
                                      <a href="#" v-on:click="onDeleteGuestGroup(row)" ref="deleteRow" style="padding-right:5px">
                                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                      </a>
                                    </td>                                    
                                    <td style="text-align:left;">{{ row.guestName }}</td>
                                    <!-- <td style="text-align:right;">{{ row.inQuota }}</td> -->
                                    <td style="text-align:left;">{{ row.relationship }}</td>
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                    <td hidden>{{ row.groupId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>                        
                      </div>
                    </div>
                  </div>                                                                     
                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                  <input type="hidden" class="form-control" id="inputMainGuestId" v-model="formData.mainGuestId">
                </div>

                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onUpdateMembership()" class="btn btn-danger pull-right">Update Membership</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right" style="margin-right:15px;">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>

              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>
    <div class="modal fade" id="modal-addGuest" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Add Guest</h4>
          </div>
          <div class="modal-body">
            <div class="box no-border form-horizontal">
              <div class="form-group">
                <label class="col-sm-6 control-label">Guest</label>
                <div class="col-sm-6">
                  <input type="text" ref="inputGuestGroup" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputGuestName" v-model="formDataDetail.guestName"
                        list="listGuestGroup" @change="onGetGuest($event)" @keyup="onSearchGuest($event)" placeholder="" >
                  <datalist id="listGuestGroup">
                    <option v-for="(row, i) in listGuest" :key="i" :value="row.text"></option>
                  </datalist>                                
                  <!-- <select2 :id="'comboGuestGroup'" :options="listAllGuest" :value="guestSelected" :enable="false">
                  </select2>  -->
                </div>                     
              </div>             
              <div class="form-group">
                <label class="col-sm-6 control-label">Relationship</label>
                <div class="col-md-6">
                  <select id="inputRelationship" v-model="formDataDetail.relationship" class="form-control" ref="relationship" :disabled="viewMode == MODE_VIEW">
                    <option value="Suami">Suami</option>
                    <option value="Istri">Istri</option>
                    <option value="Anak">Anak</option>
                    <option value="Lainnya">Lainnya</option>
                  </select>
                </div>                     
              </div> 
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button v-if="viewModeGuest == MODE_CREATE" type="button" class="btn btn-primary" @click="onContinueAddGuest($event)">Create</button>
            <button v-if="viewModeGuest == MODE_UPDATE" @click="onContinueEditGuest(formDataDetail)" class="btn btn-info" >Edit</button>
          </div>
        </div>
      </div>
      <input type="hidden" class="form-control" id="inputDetailId" v-model="formDataDetail.id">
      <input type="hidden" class="form-control" id="inputDetailGuestId" v-model="formDataDetail.guestId">      
    </div>      
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import select2 from '../../components/widgets/Select2'

const VIEW_LIST = 'list'
const VIEW_KANBAN = 'kanban'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_GUESTGROUP = 'tabGuestGroup'

export default {
  name: 'Group',
  components: {
    datepicker, select2
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      VIEW_LIST: VIEW_LIST,
      VIEW_KANBAN: VIEW_KANBAN,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_CREATE: MODE_CREATE,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_GUESTGROUP: TAB_GUESTGROUP,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      viewModeGuest: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        type: '',
        quota: '',
        mainGuestName: '',
        company: '',
        npwp: '',
        address1: '',
        address2: '',
        mainGuestId: 0
      },
      formDataDetail: {
        id: 0,
        GuestId: 0,
        GuestName: '',
        GroupId: 0,
        Relationship: ''
      },
      tabActive: '',
      listGroupType: null,
      listGuest: null,
      listGuestGroup: null,
      listAllGuestTemp: null,
      listAllGuest: null,
      guestSelected: []
    }
  },
  computed: {
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    getGroupType() {
      api
        .request('Guest', 'get', '/api/Group/GetGroupType', null)
        .then(response => {
          var data = response.data
          this.listGroupType = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getGuest(name) {
      name = name === undefined ? '' : name
      api
        .request('Guest', 'get', `/api/Guest/Inquiry?WhereClause=FirstName like '%${name}%'` +
                                 '&PageSize=' + '50' + '&CurrentPageNumber=' + '1' +
                                 '&SortDirection=' + 'ASC' + '&SortExpression=' + 'FirstName', null)
        .then(response => {
          var data = response.data
          this.listGuest = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getAllGuest() {
      api
        .request('Guest', 'get', '/api/Guest/Inquiry?WhereClause=' + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=DESC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listAllGuestTemp = data.entity
          this.listAllGuest = []
          this.listAllGuestTemp.forEach(item => {
            let objAllGuest = {
              id: item.id,
              text: item.firstName + ' ' + item.lastName
            }
            this.listAllGuest.push(objAllGuest)
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onSearchGuest(evt) {
      this.getGuest(evt.target.value)
    },
    onGetGuest(evt) {
      let guest = this.listGuest.find(x => x.firstName + ' ' + x.lastName === evt.target.value)
      if (guest) {
        this.formDataDetail.guestId = guest.id
        this.formDataDetail.guestName = evt.target.value
      }
    },
    inquiry() {
      api
        .request('Guest', 'get', '/api/Group/Inquiry?WhereClause=' + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.type = ''
      this.formData.quota = ''
      this.formData.mainGuestId = 0
      this.formData.mainGuestName = ''
      this.formData.company = ''
      this.formData.npwp = ''
      this.formData.address1 = ''
      this.formData.address2 = ''
      this.listGuestGroup = null
    },
    onSearchMainGuest(evt) {
      this.getGuest(evt.target.value)
    },
    onGetMainGuest(evt) {
      let guestMain = this.listGuest.find(x => x.firstName + ' ' + x.lastName === evt.target.value)
      if (guestMain) {
        this.formData.mainGuestId = guestMain.id
        this.formData.mainGuestName = evt.target.value
      }
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
      this.tabActive = TAB_GENERAL

      this.getGroupType()
      this.getGuest()
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW
      this.tabActive = TAB_GENERAL

      this.getGroupType()
      this.getGuest()

      api
        .request('Guest', 'get', '/api/Group/GetDetail?Id=' + row.id, null)
        .then(response => {
          var data = response.data.entity
          this.formData.id = data.id
          this.formData.name = data.name
          this.formData.type = data.type
          this.formData.quota = data.quota
          this.formData.mainGuestId = data.mainGuestId
          this.formData.mainGuestName = data.mainGuestName
          this.formData.company = data.company
          this.formData.npwp = data.npwp
          this.formData.address1 = data.address1
          this.formData.address2 = data.address2
        })
        .then(response => {
          // get Guest FirstName + ' ' + LastName
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onEdit(data) {
      this.formData.id = data.id
      this.formData.name = data.name
      this.formData.type = data.type
      this.formData.quota = data.quota
      this.formData.company = data.company
      this.formData.npwp = data.npwp
      this.formData.address1 = data.address1
      this.formData.address2 = data.address2
      this.formData.mainGuestId = data.mainGuestId
      this.formData.mainGuestName = data.mainGuestName

      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE
      this.tabActive = TAB_GENERAL

      this.getGroupType()
      this.getGuest()
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        Type: this.formData.type,
        Quota: this.formData.quota,
        MainGuestId: this.formData.mainGuestId,
        Company: this.formData.company,
        NPWP: this.formData.npwp,
        Address1: this.formData.address1,
        Address2: this.formData.address2
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Guest', 'post', '/api/Group/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Guest', 'post', '/api/Group/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    },
    onClickTabGuestGroup() {
      // this.getAllGuest()
      api
        .request('Guest', 'get', '/api/GuestGroup/InquiryByGroupId?GroupId=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listGuestGroup = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    // onContinueAddGuest(evt) {
    //   var arrGuestSelected = $('#comboGuest').val()
    //   console.log(arrGuestSelected)

    //   var lstGuestSelected = []
    //   if (arrGuestSelected) {
    //     arrGuestSelected.forEach(element => {
    //       var objGuest = {
    //         Id: JSON.parse(element)
    //       }
    //       lstGuestSelected.push(objGuest)
    //     })
    //   }
    //   var data = {
    //     Id: this.formData.id,
    //     GuestId: lstGuestSelected
    //   }
    //   console.log(data)
    // },
    onContinueAddGuest(evt) {
      var data = {
        Id: this.formDataDetail.id,
        GuestId: this.formDataDetail.guestId,
        GroupId: this.formData.id,
        Relationship: this.formDataDetail.relationship,
        InQouta: 1
      }

      var status = 'success'
      var message = ''
      api
        .request('Guest', 'post', '/api/GuestGroup/Create', data)
        .then(response => {
          var resData = response.data
          // this.formData = resData.entity

          // if (resData.returnStatus) {
          //   this.onDisplay({id: this.formData.id, name: this.formData.name})
          // }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          return status
        })
        .then(status => {
          if (status === 'success') {
            this.$refs.btnCloseModal.click()
            this.onClickTabGuestGroup()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreateGuestGroup(data) {
      this.formDataDetail.id = 0
      this.formDataDetail.relationship = ''
      this.formDataDetail.guestId = 0
      this.formDataDetail.guestName = ''

      this.viewModeGuest = MODE_CREATE
      // this.getAllGuest()
    },
    onEditGuestGroup(data) {
      this.formDataDetail.id = data.id
      this.formDataDetail.relationship = data.relationship
      this.formDataDetail.guestId = data.guestId
      this.formDataDetail.guestName = data.guestName

      this.viewModeGuest = MODE_UPDATE
      // this.getAllGuest()
    },
    onDeleteGuestGroup(data) {
      var reqData = {
        Id: data.id
      }

      api
        .request('Guest', 'post', '/api/GuestGroup/Delete', reqData)
        .then(response => {
          let status = response.data.returnStatus ? 'success' : 'error'
          let message = response.data.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          return status
        })
        .then(status => {
          this.onClickTabGuestGroup()
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onContinueEditGuest(evt) {
      var data = {
        Id: this.formDataDetail.id,
        GuestId: this.formDataDetail.guestId,
        GroupId: this.formData.id,
        Relationship: this.formDataDetail.relationship,
        InQouta: 1
      }
      console.log(data)
      var status = 'success'
      var message = ''
      api
        .request('Guest', 'post', '/api/GuestGroup/Update', data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .then(response => {
          if (status === 'success') {
            this.$refs.btnCloseModal.click()
            this.onClickTabGuestGroup()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onUpdateMembership() {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'This process will update membership of each group members',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.updateMembership()
          SweetAlert.fire('Update Group Membership', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          // SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    updateMembership() {
      console.log(this.formData)
      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        Type: this.formData.type,
        Quota: this.formData.quota,
        MainGuestId: this.formData.mainGuestId,
        Company: this.formData.company,
        NPWP: this.formData.npwp,
        Address1: this.formData.address1,
        Address2: this.formData.address2
      }

      var status = 'success'
      var message = ''

      api
        .request('Guest', 'post', '/api/Group/SyncGroupMembership', data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// Group.vue?02ebca85